export default "__VITE_ASSET__hxz3kq_J__"